<template>
  <Grid
    class="hint text-caption-3"
    align-items="center"
    :class="hintStateClass"
    :style="{ height: 'var(--r-space-xl)' }"
  >
    <slot />
  </Grid>
</template>

<script>
export default {
  props: {
    feedback: String
  },

  computed: {
    hintStateClass() {
      if (this.feedback === 'error') return 'text-danger-1'
      if (this.feedback === 'warning') return 'text-warning-1'
      if (this.feedback === 'success') return 'text-success-1'
      return 'text-secondary-1'
    }
  }
}
</script>
